<app-breadcrumb [title]="'Formulário de Cadastro'" [breadcrumb]="'Register'"></app-breadcrumb>
<!-- section start -->
<section class="register-page section-b-space">
    <div class="container">
        <div class="row">
            <div class="col-lg-12">
                <h3>Dados Cadastrais Pessoa Jurídica</h3>
                <div class="theme-card">
                    <!-- <form class="theme-form"> -->
                    <div class="theme-form">
                        <div class="row">
                            <div class="col-md-6">
                                <label for="razaoSocial">Razão Social</label>
                                <input type="text" class="form-control" id="razaoSocial" placeholder="Razão Social"
                                    required="" [(ngModel)]="cliente.razaoSocial">
                            </div>
                            <div class="col-md-6">
                                <label for="email">Nome Fantasia</label>
                                <input type="text" class="form-control" id="nome" placeholder="Nome" required=""
                                    [(ngModel)]="cliente.nome">
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6">
                                <label for="endereco">Endereço</label>
                                <input type="text" class="form-control" id="endereco" placeholder="Rua, número"
                                    required="" [(ngModel)]="cliente.endereco">
                            </div>
                            <div class="col-md-2">
                                <label for="numero">Nº</label>
                                <input type="text" class="form-control" id="numero" placeholder="Número" required=""
                                    [(ngModel)]="cliente.numero">
                            </div>
                            <div class="col-md-2">
                                <label for="bairro">Bairro</label>
                                <input type="text" class="form-control" id="bairro" placeholder="Bairro" required=""
                                    [(ngModel)]="cliente.bairro">
                            </div>
                            <div class="col-md-2">
                                <label for="cep">CEP</label>
                                <input type="text" class="form-control" id="cep" placeholder="CEP" required=""
                                    [(ngModel)]="cliente.cep">
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-4">
                                <label for="email">Email</label>
                                <input type="text" class="form-control" id="email" placeholder="Email" required=""
                                    [(ngModel)]="cliente.email">
                            </div>
                            <div class="col-md-4">
                                <label for="cpfOuCnpj">CPF ou CNPJ</label>
                                <input type="text" class="form-control" id="cpfOuCnpj" placeholder="CPF ou CNPJ"
                                    required="" [(ngModel)]="cliente.cpfOuCnpj">
                            </div>
                            <div class="col-md-2">
                                <label for="cidade">Cidade</label>
                                <input type="text" class="form-control" id="cidade" placeholder="Cidade" required=""
                                    [(ngModel)]="cliente.cidade">
                            </div>
                            <div class="col-md-2">
                                <label for="estado">Estado</label>
                                <input type="text" class="form-control" id="estado" placeholder="Estado" required=""
                                    [(ngModel)]="cliente.estado">
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6">
                                <label for="telefone">Telefone</label>
                                <input type="text" class="form-control" id="telefone" placeholder="Telefone" required=""
                                    [(ngModel)]="cliente.telefone">
                            </div>
                            <div class="col-md-6">
                                <label for="celular">Celular</label>
                                <input type="text" class="form-control" id="celular" placeholder="Celular" required=""
                                    [(ngModel)]="cliente.celular">
                            </div>
                        </div>


                        <div class="border-product" *ngFor="let usuarios of cliente?.usuarios; index as i">
                            <div *ngIf="cliente?.usuarios[i]">
                                <h6 class="product-title">Dados Usuário - {{i + 1}}</h6>
                                <a href="javascript:void(0)" (click)="removeItem(i)" class="icon">
                                    Remover <i class="ti-trash"></i>
                                </a>
                                <div class="form-group">
                                    <div class="row">
                                        <div class="col-md-6">
                                            <label>Nome</label>
                                            <input type="text" class="form-control form-control-sm"
                                                placeholder="Inserir nome aqui" [value]="cliente?.usuarios[i]?.nome"
                                                (ngModel)="cliente?.usuarios[i]?.nome"
                                                (focusout)="inserirDadosPassageiro(i, $event, 'nome')">
                                        </div>
                                        <div class="col-md-2">
                                            <label>Email</label>
                                            <input type="text" class="form-control form-control-sm"
                                                placeholder="Inserir o email para login"
                                                [value]="cliente?.usuarios[i]?.email"
                                                (ngModel)="cliente?.usuarios[i]?.email"
                                                (focusout)="inserirDadosPassageiro(i, $event, 'email')">
                                        </div>
                                        <div class="col-md-2">
                                            <label>CPF</label>
                                            <input type="text" class="form-control form-control-sm"
                                                placeholder="Inserir CPF ou doc" [value]="cliente?.usuarios[i]?.cpf"
                                                (ngModel)="cliente?.usuarios[i]?.cpf"
                                                (focusout)="inserirDadosPassageiro(i, $event, 'cpf')">
                                        </div>
                                        <div class="col-md-2">
                                            <label>Telefone</label>
                                            <input type="text" class="form-control form-control-sm"
                                                placeholder="Telefone com DDD" [value]="cliente?.usuarios[i]?.telefone"
                                                (ngModel)="cliente?.usuarios[i]?.telefone"
                                                (focusout)="inserirDadosPassageiro(i, $event, 'telefone')">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-8">
                                <button class="btn p-3 btn-outline-secondary" (click)="adicionarPassageiro()"><i
                                        class="ti-plus"></i>Adicionar Usuário</button>
                            </div>
                            <div class="col-md-4 text-end">
                                <button class="btn btn-solid" (click)="onSubmit()">Enviar email de criação da
                                    conta</button>
                            </div>
                        </div>
                    </div>
                    <!-- </form> -->
                </div>
            </div>
        </div>
    </div>
</section>
<footer>
    <section class="section-b-space light-layout">
        <div class="container">
            <div class="row footer-theme partition-f">
                <div class="col-lg-4 col-md-6">
                    <div class="footer-title footer-mobile-title">
                        <h4>about</h4>
                    </div>
                    <div class="footer-contant">
                        <div class="footer-logo">
                            <img [src]="themeLogo" alt="logo">
                        </div>
                        <div class="footer-social">
                            <ul>
                                <li>
                                    <a href="https://pt-br.facebook.com/tourregular/" target="_blank"><i
                                            class="fa fa-facebook" aria-hidden="true"></i></a>
                                </li>
                                <li>
                                    <a href="https://www.instagram.com/confiancatur/" target="_blank"><i
                                            class="fa fa-instagram" aria-hidden="true"></i></a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="col">
                    <div class="sub-title">
                        <div class="footer-title">
                            <h4>Informações da Empresa</h4>
                        </div>
                        <div class="footer-contant">
                            <ul class="contact-list">
                                <li><i class="fa fa-map-marker"></i>Av. São Sebastião, 2852 - Quilombo, Cuiabá - MT,
                                    78045-305</li>
                                <li><i class="fa fa-phone"></i>Telefone: (65) 3314-2700</li>
                                <li><i class="fa fa-envelope-o"></i>Email: <a
                                        style="text-transform: lowercase;">receptivo@confiancaturismo.com.br</a></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <div class="sub-footer">
        <div class="container">
            <div class="row">
                <div class="col-xl-6 col-md-6 col-sm-12">
                    <div class="footer-end">
                        <p><i class="fa fa-copyright" aria-hidden="true"></i> Confiança Turismo</p>
                    </div>
                </div>
                <!-- <div class="col-xl-6 col-md-6 col-sm-12">
                  <div class="payment-card-bottom">
                    <ul>
                      <li>
                        <a><img src="assets/images/icon/visa.png" alt=""></a>
                      </li>
                      <li>
                        <a><img src="assets/images/icon/mastercard.png" alt=""></a>
                      </li>
                      <li>
                        <a><img src="assets/images/icon/paypal.png" alt=""></a>
                      </li>
                      <li>
                        <a><img src="assets/images/icon/american-express.png" alt=""></a>
                      </li>
                      <li>
                        <a><img src="assets/images/icon/discover.png" alt=""></a>
                      </li>
                    </ul>
                  </div>
                </div> -->
            </div>
        </div>
    </div>
</footer>
<!--Section ends-->

<ng-template #confirmarModal let-modal>
    <div class="modal-body">
        <form>
            <div class="mb-3 row">
                <h3 class="text-center">Seu email está sendo enviado!</h3>
                <h4 class="text-center">Assim que concluído será direcionado para tela de login.</h4>
            </div>
        </form>
    </div>
</ng-template>